module.exports = __webpack_public_path__ + "img/high expedition.f05abb19.png";